export const SKELETONS = [
	{width: '100%', height: 149},
	{width: '50%', height: 79},
	{width: '100%', height: 149},
	{width: '50%', height: 79},
	{width: '100%', height: 79},
];
